import { render } from "./EditWellnessBookingDialog.vue?vue&type=template&id=39f941b0"
import script from "./EditWellnessBookingDialog.vue?vue&type=script&lang=js"
export * from "./EditWellnessBookingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__